import UmbracoForm from '@stories/Components/Forms/UmbracoForm/UmbracoForm';
import * as React from 'react';
import S from './EmbeddedForm.styles';
const EmbeddedForm = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.ContentInner, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }))),
        React.createElement(S.FormWrapper, null,
            React.createElement(UmbracoForm, { ...props.formConfig }))));
};
export default EmbeddedForm;
